import DefaultMapper, {toPagingAndSorting} from '../../dataProvider/DefaultMapper';
import {API_BASE_PATH_ADMIN} from "../../constants";
import { stringify } from 'query-string';

class MT940FileRecordMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'payment/mt940/files';
	}

	prepareGetOne({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/records/${params.id}`;
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		const query = toPagingAndSorting(params);
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.filter.id}/records?${stringify(query)}`;
	}

	prepareUpdate({ params, options }) {
		options.url = `${API_BASE_PATH_ADMIN}/payment/mt940/files/records/${params.data.id}:changeStatus`;
		options.method = 'POST';
		const data = {
			comment: params.data.comment,
			status: params.data.status
		};
		options.body = JSON.stringify(data);
	}

}

export default MT940FileRecordMapper;
